const EnrollStyle = {
  inputStyle: {
    borderRadius: "2rem",
    bgcolor: "rgb(225 245 254)",
    boxShadow: 2,
  },
};

export default EnrollStyle;
